import config from '@/config'
import Invitations, { IInvitations } from '@/models/Invitations'
import BaseService from './BaseService'
import { requests } from './HTTPService'
const http = requests(config?.COMMUNITIES_SERVER_URL)

export default class InvitationsService extends BaseService<Invitations> {
  readonly groupId: string

  model(): typeof Invitations {
    return Invitations
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.groupId = groupId
    this.basePath = `/${locationId}/groups/${groupId}/invitations`
  }

  async create(data: IInvitations): Promise<any> {
    const response = await http.post(`${super.endpoint}`, data)
    return response?.data
  }

  async acceptInvitation(invitationId: string): Promise<any> {
    const response = await http.post(
      `${super.endpoint}/${invitationId}/accept`,
      {}
    )
    return response?.data
  }
}
